<template>
    <svg viewBox="0 0 112 112" width="112" height="112" class="x14rh7hd x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq"
        style="--x-color: var(--primary-icon);">
        <defs>
            <clipPath id="a">
                <path fill="#a4a7ab" d="M94.38 98.59H21.51V11.18h44.55l28.32 23.45v63.96z"></path>
            </clipPath>
        </defs>
        <path fill="#a4a7ab" d="M94.38 98.59H21.51V11.18h44.55l28.32 23.45v63.96z"></path>
        <g clip-path="url(#a)">
            <path fill="#a4a7ab" d="M94.38 98.59H21.51V11.18h44.55l28.32 23.45v63.96z"></path>
            <path fill="#1876f2" d="M65.94 8.72h32.27v25.95H73a7 7 0 0 1-7-7V8.72h-.06z"></path>
        </g>
        <rect width="57.1" height="3.51" x="29.39" y="47.67" fill="#fff" rx="1.68"></rect>
        <rect width="57.1" height="3.51" x="29.39" y="58.2" fill="#fff" rx="1.68"></rect>
        <rect width="57.1" height="3.51" x="29.39" y="68.73" fill="#fff" rx="1.68"></rect>
    </svg>
</template>